import React from "react";
import "./../styles/variable-projects.css";
import Projectsvariable from "../components/variable-projects";
import imagem1 from '../assets/images/Projetos/Novo Maracanã/maraca_novo.jpg';
import imagem2 from '../assets/images/Projetos/Novo Maracanã/maraca_novo-img2.jpg';
import imagem3 from '../assets/images/Projetos/Novo Maracanã/maraca_novo-img3.jpg';

const App = () => {
  const projectData = {
    date: "20/02/2017",
    title: "Novo Maracanã",
    images: [
      imagem1,
      imagem2,
      imagem3
    ],
    description:
    "Fornecimento de cabeamento para controle de acesso e CFTV no estádio novo Maracanã.",
    solutions: [""],
  };

  return <Projectsvariable {...projectData} />;
};

export default App;